import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminAuthenticationGuard } from './services/admin-authentication.guard';
import { LesseeAuthenticationGuard } from './services/lessee-authentication.guard';
import { SuperAdminAuthenticationGuard } from './services/super-admin-authentication.guard';

import { LoginComponent } from './public/login/login.component';
import { LogoutTimerComponent } from './public/logoutTimer/logoutTimer.component';
import { MarketingLandingComponent } from './public/marketing-landing/marketing-landing.component';
import { AdminLandingComponent } from './admin/admin-landing/admin-landing.component';
import { MessageRespondComponent } from './admin/message-respond/message-respond.component';
import { AdminAllMessagesComponent } from './admin/admin-all-messages/admin-all-messages.component';
import { StartLeaseComponent } from './admin/start-lease/start-lease.component';
import { ModifyLeaseComponent} from './admin/modify-lease/modify-lease.component';
import { AdminInvoicesComponent } from './admin/admin-invoices/admin-invoices.component';
import { ExternalPaymentComponent } from './admin/external-payment/external-payment.component';
import { ContactInfoComponent } from './admin/contact-info/contact-info.component';
import { CreateUserComponent } from './admin/createUser/createUser.component';
import { ManageLeasesComponent } from './admin/manage-leases/manage-leases.component';
import { PropertyExpensesComponent } from './admin/property-expenses/property-expenses.component';
import { ReceiptViewComponent } from './admin/receipt-view/receipt-view.component';
import { PropertyStatementsComponent } from './admin/property-statements/property-statements.component';
import { StatementViewComponent } from './admin/statement-view/statement-view.component';
import { OrganizationExpensesComponent } from './admin/organization-expenses/organization-expenses.component';
import { OrgReceiptViewComponent } from './admin/org-receipt-view.component';
import { ResetPasswordComponent } from './public/reset-password/reset-password.component';
import { LesseeLandingComponent } from './lessee/lessee-landing/lessee-landing.component';
import { LesseePaymentComponent } from './lessee/lessee-payment/lessee-payment.component';
import { OnePropertyViewComponent } from './common/one-property-view/one-property-view.component';
import { AddresformComponent } from './public/test/addresform/addresform.component';
import { SuperAdminComponent } from './admin/super-admin/super-admin.component';
import { OrganizationSettingsComponent } from './admin/organization-settings/organization-settings.component';
import { InvoicePdfComponent } from './common/invoice-pdf/invoice-pdf.component';
import { LeaseDocumentPdfComponent } from './common/lease-document-pdf/lease-document-pdf.component';
import { ReportsComponent } from './admin/reports/reports.component';
import { EditPropertyComponent } from './admin/edit-property/edit-property.component';
import { ArchivedPropertiesComponent } from './admin/archived-properties/archived-properties.component';

const routes: Routes = [
  {
    path: '',
    component: MarketingLandingComponent
  },
  {
    path: 'createUser',
    component: CreateUserComponent,
    canActivate: [ AdminAuthenticationGuard ]
  },
  {
    path: 'organization-settings',
    component: OrganizationSettingsComponent,
    canActivate: [ AdminAuthenticationGuard ]
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'logoutTimer',
    component: LogoutTimerComponent
  },
  {
    path: 'admin-landing',
    component: AdminLandingComponent,
    canActivate: [ AdminAuthenticationGuard ]
  },
  {
    path: 'message-respond',
    component: MessageRespondComponent,
    canActivate: [ AdminAuthenticationGuard ]
  },
  {
    path: 'all-messages',
    component: AdminAllMessagesComponent,
    canActivate: [ AdminAuthenticationGuard ]
  },
  {
    path: 'start-lease/:propertyId',
    component: StartLeaseComponent,
    canActivate: [ AdminAuthenticationGuard ]
  },
  {
    path: 'start-lease',
    component: StartLeaseComponent,
    canActivate: [ AdminAuthenticationGuard ]
  },
  {
    path: 'modify-lease',
    component: ModifyLeaseComponent,
    canActivate: [ AdminAuthenticationGuard ]
  },
  {
    path: 'manage-leases',
    component: ManageLeasesComponent,
    canActivate: [ AdminAuthenticationGuard ]
  },
  {
    path: 'property-expenses',
    component: PropertyExpensesComponent,
    canActivate: [ AdminAuthenticationGuard ]
  },
  {
    path: 'property-statements',
    component: PropertyStatementsComponent,
    canActivate: [ AdminAuthenticationGuard ]
  },
  {
    path: 'organization-expenses',
    component: OrganizationExpensesComponent,
    canActivate: [ AdminAuthenticationGuard ]
  },
  {
    path: 'reports',
    component: ReportsComponent,
    canActivate: [ AdminAuthenticationGuard ]
  },
  {
    path: 'expense-receipt',
    component: ReceiptViewComponent,
    canActivate: [ AdminAuthenticationGuard ]
  },
  {
    path: 'statement-view',
    component: StatementViewComponent,
    canActivate: [ AdminAuthenticationGuard ]
  },
  {
    path: 'org-expense-receipt',
    component: OrgReceiptViewComponent,
    canActivate: [ AdminAuthenticationGuard ]
  },
  {
    path: 'admin-invoices',
    component: AdminInvoicesComponent,
    canActivate: [ AdminAuthenticationGuard ]
  },
  {
    path: 'external-payment',
    component: ExternalPaymentComponent,
    canActivate: [ AdminAuthenticationGuard ]
  },
  {
    path: 'contact-info',
    component: ContactInfoComponent,
    canActivate: [ AdminAuthenticationGuard ]
  },
  {
    path: 'lessee-landing',
    component: LesseeLandingComponent,
    canActivate: [ LesseeAuthenticationGuard ]
  },
  {
    path: 'lessee-payment',
    component: LesseePaymentComponent
  },
  {
    path: 'invoice/:id/pdf',
    component: InvoicePdfComponent
  },
  {
    path: 'lease-document/:propertyId/:documentId',
    component: LeaseDocumentPdfComponent,
    canActivate: [ AdminAuthenticationGuard ]
  },
  {
    path: 'view-property/:id',
    component: OnePropertyViewComponent
  },
  {
    path: 'admin-landing/view-property/:id',
    component: OnePropertyViewComponent,
    canActivate: [ AdminAuthenticationGuard ]
  },
  {
    path: 'edit-property/:id',
    component: EditPropertyComponent,
    canActivate: [ AdminAuthenticationGuard ]
  },
  {
    path: 'archived-properties',
    component: ArchivedPropertiesComponent,
    canActivate: [ AdminAuthenticationGuard ]
  },
  {
    path: 'address',
    component: AddresformComponent
  },
  {
    path: 'super-admin',
    component: SuperAdminComponent,
    canActivate: [ SuperAdminAuthenticationGuard ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
